import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";

import "./UpdateSpecsPromptModal.css";

export default function UpdateSpecsPromptModal({
  open,
  testName,
  onOpenChange,
  onUpdateSpecs,
  onNotNow,
  onDontShowAgain,
  children,
}) {
  const content = (
    <div className="UpdateSpecsPromptPopover__Card">
      <div className="UpdateSpecsPromptPopover__Header">
        <span id="update-specs-prompt-title" className="UpdateSpecsPromptPopover__Title">
          Update specs?
        </span>
        <Button
          type="text"
          icon={<CloseOutlined />}
          className="UpdateSpecsPromptPopover__Close"
          aria-label="Close"
          onClick={onNotNow}
        />
      </div>

      <div className="UpdateSpecsPromptPopover__Body">
        <p className="UpdateSpecsPromptPopover__Lead">
          You released out of range results for the following tests. Update the specifications to prevent future flags.
        </p>
        <span className="UpdateSpecsPromptPopover__TestChip" title={testName || ""}>
          {testName || "Test"}
        </span>
      </div>

      <div className="UpdateSpecsPromptPopover__Footer">
        <Button type="text" className="UpdateSpecsPromptPopover__DontShow" onClick={onDontShowAgain}>
          Don&apos;t show this suggestion again
        </Button>
        <div className="UpdateSpecsPromptPopover__FooterActions">
          <Button type="default" onClick={onNotNow}>
            Not Now
          </Button>
          <Button type="primary" onClick={onUpdateSpecs}>
            Update Specs
          </Button>
        </div>
      </div>
    </div>
  );

  return (
    <Popover
      open={open}
      onOpenChange={onOpenChange}
      content={content}
      trigger={[]}
      placement="topRight"
      arrow={{ pointAtCenter: true }}
      getPopupContainer={() => document.body}
      classNames={{ root: "UpdateSpecsPromptPopover" }}
      destroyTooltipOnHide
    >
      {children}
    </Popover>
  );
}
